import React from 'react';
export function Logo({
  className = '',
  height = 140
}: {
  className?: string;
  height?: number;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/qSiX599E5bZBjLNEkXu5MT/logotipo_trasnparentre.png" alt="Cabrera Resto-Bar" style={{
    height: `${height}px`,
    width: 'auto',
    objectFit: 'contain',
    display: 'block'
  }} className={`w-auto object-contain ${className}`} data-id="element-228" />;
}